import React, { useEffect } from 'react';
import { Body, SubmitButton, FormCadastro, PageHeader, Input, Field, GroupField } from '@components';
import { getClientesConectores } from '@ducks/clientes';
import { Notification } from '@utils';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import TreeConectores from './TreeConectores';
import App from '@app';
import { getNotificacaoEmail, postNotificacaoEmail, reset } from '@ducks/conectoresNotificacao';

export default function Detalhes() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [form] = FormCadastro.useForm();
  const { id } = useParams();
  const edicao = id !== '-1';

  const clientesConectores = useSelector(({ clientes }) => clientes.get('clientesConectores').toArray());
  const conectoresSelecionados = useSelector(({ conectoresNotificacao }) => conectoresNotificacao.get('conectoresSelecionados'));
  const successPostNotificacaoEmail = useSelector(({ conectoresNotificacao }) => conectoresNotificacao.get('successPostNotificacaoEmail'));

  const email = useSelector(({ conectoresNotificacao }) => conectoresNotificacao.get('email'));
  const successNotificacaoEmail = useSelector(({ conectoresNotificacao }) => conectoresNotificacao.get('successNotificacaoEmail'));

  const handleReset = () => {
    return dispatch(reset());
  };

  const handleSearch = () => {
    return dispatch(getClientesConectores());
  };

  useEffect(() => {
    if (edicao) {
      dispatch(getNotificacaoEmail(id));
    }
  }, []);

  useEffect(() => {
    if (email && edicao) {
      form.setFieldsValue(email);
    }
  }, [successNotificacaoEmail]);

  useEffect(() => {
    handleReset();
    handleSearch();
  }, []);

  useEffect(() => {
    if (successPostNotificacaoEmail) {
      handleReset();
      history.goBack();
    }
  }, [successPostNotificacaoEmail]);

  function handleSubmit(data) {
    if (conectoresSelecionados.length === 0) {
      Notification.error('Selecione ao menos um conector');
      return;
    }

    const conectores = [];

    conectoresSelecionados.forEach((conector) => {
      const configuracao = conector.split('-');

      if (configuracao[1] === '0') {
        const cliente = clientesConectores.find((cliente) => cliente.key === conector);

        cliente.children.forEach((configuracao) => {
          conectores.push(parseInt(configuracao.key.split('-')[1]));
        });
      } else {
        conectores.push(parseInt(configuracao[1]));
      }
    });
    dispatch(postNotificacaoEmail({ ...data, conectores }));
  }

  return (
    <App>
      <Body>
        <PageHeader title='Notificação dos Conectores' onBack={() => history.goBack()}>
          <FormCadastro form={form} hideRequiredMark onFinish={handleSubmit}>
            <GroupField>
              <Field label='Email' name='email' rules={[{ type: 'email', message: 'O email não é válido' }]}>
                <Input autoFocus />
              </Field>
            </GroupField>
            <GroupField>
              <Field label='Conectores'>
                <TreeConectores treeData={clientesConectores} />
              </Field>
            </GroupField>
            <SubmitButton type='success' htmlType='submit' block>
              Salvar
            </SubmitButton>
          </FormCadastro>
        </PageHeader>
      </Body>
    </App>
  );
}
